module.exports = __webpack_public_path__ + "img/yzw.12b25f21.jpg";